import React, { useCallback, useEffect, useState } from 'react';
import {
    deleteCuttingCard,
    fetchCuttingCards,
} from '../../app/api/CuttingCard';
import { toast } from 'react-toastify';
import _ from 'lodash';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import PaginationClassic from '../../components/pagination/PaginationClassic';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { Printer, Trash2 } from 'react-feather';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { useFormik } from 'formik';
import FormikSelectGroup from '../../components/formik/FormikSelectGroup';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import { CUTTING_CARD_STATUS } from '../../utils/dropdownOptions';
import QueryString from 'qs';
import DangerButton from '../../components/infrastructure/Buttons/DangerButton';
import moment from 'moment-timezone';

const ViewCuttingCards = () => {
    const [loading, setLoading] = useState(false);
    const [cuttingCards, setCuttingCards] = useState({});
    console.log('cards', cuttingCards);
    const [selectedRows, setSelectedRows] = useState([]);
    const [page, setPage] = useState(1);
    const navigate = useNavigate();

    const getCuttingCards = async (fetchPayload) => {
        try {
            setLoading(true);

            const cardResp = await fetchCuttingCards(fetchPayload);
            setCuttingCards(cardResp.data);
        } catch (error) {
            toast.error('Failed to fetch cutting cards');
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const formik = useFormik({
        initialValues: {
            status: '',
            createdAtFrom: null,
            createdAtTo: null,
            receiveDateFrom: null,
            receiveDateTo: null,
        },
        onSubmit: (values) => {
            console.log('filter values', values);
            const query = {};
            if (values?.status) {
                query['status'] = values?.status;
            }
            if (values?.createdAtFrom && values?.createdAtTo ) {
                query['createdAt'] = {
                    $gte: moment(values?.createdAtFrom).startOf('day').valueOf(),
                    $lte: moment(values?.createdAtTo).endOf('day').valueOf(),
                };
            }
            if (values?.receiveDateFrom && values?.receiveDateTo) {
                query['receiveDate'] = {
                    $gte: moment(values?.receiveDateFrom).startOf('day').valueOf(),
                    $lte: moment(values?.receiveDateTo).endOf('day').valueOf(),
                };
            }

            getCuttingCards(query);
        },
    });

    const cols = [
        {
            Header: 'Select',
            Cell: ({ row }) => (
                <input
                    type="checkbox"
                    checked={selectedRows.some(
                        (ele) => ele._id === row?.original?._id
                    )}
                    onChange={(e) => {
                        e.currentTarget.checked;
                        if (e.currentTarget.checked) {
                            setSelectedRows([...selectedRows, row?.original]);
                        } else {
                            const filtered = selectedRows?.filter(
                                (ele) => ele?._id !== row?.original?._id
                            );
                            setSelectedRows(filtered);
                        }
                    }}
                />
            ),
        },
        {
            Header: 'Date',
            Cell: ({ row }) => {
                return (
                    <div>
                        {moment
                            .tz(row?.original?.date, 'Asia/Kolkata')
                            .format('DD-MM-YYYY')}
                    </div>
                );
            },
        },
        {
            Header: 'Receive Date',
            Cell: ({ row }) => {
                return (
                    <div>
                        {row?.original?.receiveDate ? moment
                            .tz(row?.original?.receiveDate, 'Asia/Kolkata')
                            .format('DD-MM-YYYY') : ''}
                    </div>
                );
            },
        },
        {
            Header: 'Cutting Card No',
            accessor: 'cuttingCardNumber',
        },
        {
            Header: 'Mill Challan No',
            accessor: 'millChallanNo',
        },
        {
            Header: 'Mill Name',
            accessor: 'millName',
        },
        {
            Header: 'Status',
            accessor: 'status',
        },
        {
            Header: 'Lot No',
            accessor: 'lotNo',
        },
        {
            Header: 'Notes',
            accessor: 'notes',
        },
        {
            Header: 'Action',
            Cell: ({ row }) => {
                return (
                    <div className="flex flex-row items-center gap-2">
                        {row?.original?.status === 'pending' && (
                            <PrimaryButton
                                onClick={() => {
                                    navigate(
                                        `/receive-cutting-card/${row.original.cuttingCardNumber}`
                                    );
                                }}
                            >
                                Receive
                            </PrimaryButton>
                        )}
                        <PrimaryButton
                            className="p-1"
                            size={18}
                            onClick={async (e) => {
                                e.stopPropagation();
                                const response = await authAxiosInstance.post(
                                    `/cuttingCard/cuttingCardPdf`,
                                    row?.original
                                );
                                const printWindow = window.open('', '_blank');
                                printWindow.document.write(response.data);
                            }}
                        >
                            <Printer size={20} />
                        </PrimaryButton>
                        <Trash2
                            color="red"
                            onClick={() => {
                                deleteCuttingCard(row.original._id);
                                getCuttingCards({ page });
                            }}
                        />
                    </div>
                );
            },
        },
    ];

    const debouncedSearch = useCallback(
        _.debounce(async (search) => {
            getCuttingCards({ search: search, page: 1 });
        }, 300),
        []
    );

    useEffect(() => {
        getCuttingCards({ page });
    }, [page]);

    return (
        <PageWithCard heading="Cutting Cards">
            <div className="">
                <form
                    className="p-4 border rounded-lg flex flex-col gap-4 mb-4"
                    onSubmit={formik.handleSubmit}
                >
                    <div className="flex flex-row items-center gap-4">
                        <div className="flex flex-row w-full items-center gap-4 border rounded-lg p-2">
                            <div className="w-full">
                                <FormikInputDateGroup
                                    formik={formik}
                                    label="Created Date From"
                                    name="createdAtFrom"
                                />
                            </div>
                            <div className="w-full">
                                <FormikInputDateGroup
                                    formik={formik}
                                    label="Created Date To"
                                    name="createdAtTo"
                                />
                            </div>
                        </div>
                        <div className="flex flex-row w-full items-center gap-4 border rounded-lg p-2">
                            <div className="w-full">
                                <FormikInputDateGroup
                                    formik={formik}
                                    label="Receive Date From"
                                    name="receiveDateFrom"
                                />
                            </div>
                            <div className="w-full">
                                <FormikInputDateGroup
                                    formik={formik}
                                    label="Receive Date To"
                                    name="receiveDateTo"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-row items-center gap-4">
                        <div className="w-[25%] border rounded-lg p-2">
                            <FormikSelectGroup
                                formik={formik}
                                name="status"
                                label="Status"
                                options={CUTTING_CARD_STATUS}
                            />
                        </div>
                    </div>
                    <div className="flex flex-row items-center gap-4">
                        <PrimaryButton type="submit">Filter</PrimaryButton>
                        <DangerButton
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation();
                                getCuttingCards({ page });
                                formik.setFieldValue('status', '');
                                formik.setFieldValue('createdAtFrom', null);
                                formik.setFieldValue('createdAtTo', null);
                                formik.setFieldValue('receiveDateFrom', null);
                                formik.setFieldValue('receiveDateTo', null);
                            }}
                        >
                            Clear
                        </DangerButton>
                    </div>
                </form>
                <TableWithHeadingAndGlobalSearch
                    heading={
                        <div className="flex flex-row items-center gap-4">
                            <h2 className="font-semibold text-slate-800">
                                Cutting Cards
                            </h2>
                            {selectedRows?.length > 0 && (
                                <PrimaryButton
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        try {
                                            setLoading(true);
                                            const response =
                                                await authAxiosInstance.post(
                                                    `/cuttingCard/multipleCuttingCardPdf`,
                                                    selectedRows
                                                );
                                            const printWindow = window.open(
                                                '',
                                                '_blank'
                                            );
                                            if (printWindow) {
                                                printWindow.document.write(
                                                    response.data
                                                );
                                                printWindow.document.close();
                                            } else {
                                                console.error(
                                                    'Popup blocked or failed to open.'
                                                );
                                                toast.error(
                                                    'Failed to open print window. Please allow popups.'
                                                );
                                            }
                                            setLoading(false);
                                        } catch (error) {
                                            console.log('error', error);
                                            toast.error(
                                                'Failed to create multiple pdf'
                                            );
                                        } finally {
                                            setLoading(false);
                                        }
                                    }}
                                >
                                    <Printer size={18} className="mr-2" />{' '}
                                    {`Selected (${selectedRows?.length})`}
                                </PrimaryButton>
                            )}
                            {selectedRows.length > 0 && (
                                <PrimaryButton
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedRows([]);
                                    }}
                                >
                                    Clear
                                </PrimaryButton>
                            )}
                        </div>
                    }
                    columns={cols}
                    searchFunction={debouncedSearch}
                    loading={loading}
                    data={
                        cuttingCards?.docs?.length > 0 ? cuttingCards.docs : []
                    }
                />
                <PaginationClassic
                    paginationDetails={cuttingCards}
                    setPage={setPage}
                />
            </div>
        </PageWithCard>
    );
};

export default ViewCuttingCards;
